/**
 * Responsibility: Shape admin invite form data for field-assist.
 * Scope: Invite form metadata only.
 */
import type { FormMetaData } from 'field-assist'

export function buildAdminInviteFormMeta(): FormMetaData {
  return {
    email: {
      label: 'Invite Email',
      componentType: 'input',
      attributes: {
        type: 'email',
        placeholder: 'tester@example.com',
        class: 'admin-invite-input',
      },
    },
  }
}
